import { useSelector } from 'react-redux'
import Inner from '@components/Ui/Inner'
import Spacer from '@components/Ui/Spacer'
import { Sizer } from '@components/Ui/Grid'
import { Type, Location, DateTime, Review, Confirmation, Error } from '@components/Steps'
import {
  STEP_TYPE,
  STEP_LOCATION,
  STEP_DATETIME,
  STEP_REVIEW,
  STEP_CONFIRMATION,
  STEP_ERROR,
} from '@names'
import styles from './Body.scss'

const Body = () => {
  const step = useSelector((s) => s.app.step)

  return (
    <Inner className={styles.base}>
      <Sizer
        size="10/12@md 8/12@lg"
        push="1/12@md 2/12@lg"
        pull="1/12@md 2/12@lg"
        className={styles.container}
      >
      <Spacer vertical scale="1" />
      {step === STEP_TYPE && <Type />}
      {step === STEP_LOCATION && <Location />}
      {step === STEP_DATETIME && <DateTime />}
      {step === STEP_REVIEW && <Review />}
      {step === STEP_CONFIRMATION && <Confirmation />}
      {step === STEP_ERROR && <Error />}
      <Spacer vertical scale="1" />
      </Sizer>
    </Inner>
  )
}

Body.defaultProps = {}
Body.propTypes = {}

export default Body
